export const ReceiptContent = {
  modalContent: {
    divcapgains: {
      header: `Dividends and capital gains`,
      paragraphs: [
        `Reinvesting means the dividends and capital gains distributions from eligible investments will be used to buy additional shares of those investments. We'll do this automatically for you through the Vanguard Brokerage dividend reinvestment program, which has no fees or commissions.<br><br>`,
        `You can change your dividend selection for all eligible investments or for specific investments after your account has been opened by going to your <b>Profile \u0026 account settings.</b>`,
      ],
    },
    settlementFund: {
      header: `Settlement fund`,
      paragraphs: [
        `Your account comes with the Vanguard Federal Money Market Fund—a settlement fund (or "sweep account") that is used to hold assets from your investment transactions. You can change your settlement fund election to <u>Vanguard Cash Deposit</u> in your <b>Profile & account settings</b> after your account is open.`,
      ],
    },
    beneficiaries: {
      header: `Beneficiaries`,
      paragraphs: [
        `Assets will pass to your spouse if married or estate if not married upon your death according to the Vanguard IRA Custodial Account Agreement. This is the default beneficiary designation unless you change it.<br><br>`,
        `You can update your beneficiaries after your new account has been opened by going to the accounts \u0026 trading tab in your profile \u0026 account settings.`,
      ],
    },
    giftingYearEnd: {
      header: `Gifting Timing`,
      paragraphs: [
        `Your gift request will take 1-3 days to process and may not be completed until the following IRS tax-year.`,
      ],
    },
  },
};
